import React from 'react'

interface DataPointNodeProps {
  data: {
    color: string
    selected?: boolean
    label?: string
  }
}

const DataPointNode: React.FC<DataPointNodeProps> = ({ data }) => {
  return (
    <div
      style={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: data.color,
        border: data.selected ? '2px solid #fbbf24' : '1px solid rgba(255, 255, 255, 0.5)',
        cursor: 'pointer',
        boxShadow: data.selected ? '0 0 8px rgba(251, 191, 36, 0.8)' : 'none',
        transition: 'all 0.2s ease',
      }}
      title={data.label}
    />
  )
}

export default DataPointNode
